import { CompoundDiceType } from "./Dice";
import { DiceUtils } from "./Dice";

export const DataInputKey = "DataInput";

export enum StatFeatureEnum {
    DEFAULT,
    ADDEND,
    MODIFIER,
    DICE
}

export type StatAddend = {
    type: StatFeatureEnum.ADDEND;
    value: number | (() => number);
};

export type StatModifier = {
    type: StatFeatureEnum.MODIFIER;
    value: (input: number) => number;
};

export type StatDice = {
    type: StatFeatureEnum.DICE;
    value: CompoundDiceType;
};

export type StatFeature = StatAddend | StatModifier | StatDice;

export class StatFeatureUtils {
    public static stringify(feature: StatFeature): string {
        switch (feature.type) {
            case StatFeatureEnum.ADDEND:
                if (typeof feature.value === "number") {
                    return feature.value.toString();
                } else {
                    return feature.value().toString();
                }
            case StatFeatureEnum.MODIFIER:
                return `x => ${feature.value(1)}x`;
            case StatFeatureEnum.DICE:
                return DiceUtils.stringify(...feature.value);
        }
    }
}
